import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function HowToModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="howto-modal"
        className="bg-white border border-slate-200 rounded-2xl max-w-lg p-0 overflow-hidden"
      >
        <div className="px-6 pt-5">
          <DialogHeader>
            <p className="text-[11px] font-mono tracking-[0.2em] uppercase text-slate-500">
              How to play
            </p>
            <DialogTitle
              className="text-slate-900 text-2xl font-bold tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              DxDaily
            </DialogTitle>
          </DialogHeader>
        </div>

        <div className="px-6 pb-6 space-y-4 text-sm text-slate-700 leading-relaxed">
          <p>
            Each day you get one clinical condition. Ask up to <b>5 yes/no
            questions</b> from a dropdown of 15, then commit to a single diagnosis.
          </p>

          <div className="space-y-2">
            <div className="flex items-center gap-3 rounded-lg bg-emerald-500 px-4 py-3">
              <span className="text-white text-xs font-mono tracking-widest uppercase bg-white/20 rounded-full px-2 py-0.5">
                Yes
              </span>
              <span className="text-white text-sm">
                A useful, relevant question — bringing you closer to the diagnosis.
              </span>
            </div>
            <div className="flex items-center gap-3 rounded-lg bg-red-500 px-4 py-3">
              <span className="text-white text-xs font-mono tracking-widest uppercase bg-white/20 rounded-full px-2 py-0.5">
                No
              </span>
              <span className="text-white text-sm">
                A wasted question — this fact is not useful for this case.
              </span>
            </div>
          </div>

          <p>
            Only <b>5 of the 15</b> questions are helpful for today&apos;s case.
            Choose wisely — quality beats quantity.
          </p>

        <p className="text-slate-500 text-xs">
            A new case for every discipline drops daily at 00:00 Pacific Time.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
